import { render, staticRenderFns } from "./ButtonToggles.vue?vue&type=template&id=09147c61&scoped=true&"
import script from "./ButtonToggles.vue?vue&type=script&lang=ts&"
export * from "./ButtonToggles.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonToggles.vue?vue&type=style&index=0&id=09147c61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09147c61",
  null
  
)

export default component.exports